module.exports = /*@ngInject*/ function ($scope, $q, $window, $timeout, $location, FilterProvider, RealEstateSpinner) {
    let projectsUrl;
    let timer;
    let initialFilter = {};
    let inited = false;

    $scope.amount = null;
    $scope.types = [];
    $scope.types2 = [];
    $scope.location = [];
    $scope.locations = [];
    $scope.locationText = [];
    $scope.kategoria = [];
    $scope.states = [];
    $scope.countries = [];
    $scope.regions = [];
    $scope.cities = [];
    $scope.categories = [];
    $scope.loadingFilter = true;
    $scope.spinner = RealEstateSpinner.proccess;
    $scope.filterVersion = null;
    $scope.stepPrice=500;
    $scope.filter = {
        country: '',
        balcon: 0,
        breadcrumbs: false,
        category: [],
        city: [],
        coordinates: [],
        coordinateType: '',
        fullText: '',
        kategoria: [],
        locationText: [],
        locationTextMobile: '',
        new: 0,
        priceFrom: 0,
        priceTo: 0,
        region: [],
        sizeFrom: '',
        sizeTo: '',
        specie: '',
        state: '',
        type: '',
        types: [],
        virtual: 0,
    };

    $scope.init = init;
    $scope.filterProjects = filterProjects;
    $scope.toggleCategory = toggleCategory;
    $scope.toggleRegion = toggleRegion;
    $scope.toggleCity = toggleCity;

    $scope.$watch('filter', function (val, oldVal) {
        if (val == oldVal) {
            loadAmount();
        } else {
            $timeout.cancel(timer);
            timer = $timeout(function () {
                loadAmount();
            }, 200);
        }
    }, true);

    $scope.$watch('location', function (location, oldVal) {
        if (location !== oldVal) {
            const isCountry = $scope.countries.some(function (country) {
                return country.id === location[0].id;
            });

            $scope.regions = [];
            $scope.filter.region = [];
            $scope.filter.city = [];
            $scope.cities = [];

            if (isCountry) {
                loadRegions(location[0].id);
                $scope.filter.country = location[0].id;
                $scope.filter.state = '';

            } else {
                $scope.filter.state = location[0].id;
                $scope.filter.country = '';
            }
        }
    }, true);

    $scope.$watch('type', function (type, oldVal) {
        if (type !== oldVal) {
            if(Array.isArray(type) && type.length>0){
                $scope.filter.type = type[0].value;
                if(type[0].value==='Prenájom'){
                    $scope.stepPrice=100;
                }
                else{
                    $scope.stepPrice=500;
                }
            }
        }
    });

    $scope.$watch('specie', function (specie, oldVal) {  
        if (specie !== oldVal) {       
            if(Array.isArray(specie) && specie.length>0){
                $scope.filter.specie = specie[0].value;  
            }
        }
    });

    $scope.$watch('filter.region', function (regionsId, oldVal) {
        if (regionsId !== oldVal) {
            loadCities(regionsId);
            $scope.filter.city = [];
        }
    });

    $scope.$watch('filter.specie', function (specieId, oldVal) {
        if (angular.equals(specieId, oldVal)) {
            return;
        }
        // After init, changing specie resets subcategories.
        // During init we must keep category[] from URL.
        if (inited) {
            $scope.filter.category = [];
        }
        loadCategories(specieId);
    }, true);

    $scope.$watch('filter.kategoria', function (newVal, oldVal) {
        if (oldVal != newVal && $scope.filterVersion == 'B' && newVal.length == 0) {
            $scope.filter.specie = '';
            $scope.filter.category = [];
        }
    });

    $scope.$watch('filter.locationText', function (newVal, oldVal) {
        if (oldVal != newVal && $scope.filterVersion == 'B' && newVal.length == 0) {
            $scope.regions = [];
            $scope.filter.region = [];
            $scope.filter.city = [];
            $scope.cities = [];
            $scope.filter.country = '';
            $scope.filter.state = '';
        }
    });

    function getQueryParamArray(name) {
        const search = $location.search();
        let value = search[name + '[]'];

        if (angular.isUndefined(value) || value === null || value === '') {
            value = search[name];
        }

        if (angular.isUndefined(value) || value === null || value === '') {
            return [];
        }

        return angular.isArray(value) ? value : [value];
    }

    function init(p_projectsUrl, filterVersion = null) {
        $scope.filterVersion = filterVersion;
        projectsUrl = p_projectsUrl;
        inited = false;

        let geoJSON = {};
        if ($location.search()['geoJSON[type]']) {
            geoJSON['type'] = $location.search()['geoJSON[type]'];
        }
        if ($location.search()['geoJSON[box][0][]']) {
            geoJSON['box'] = [
                $location.search()['geoJSON[box][0][]'],
                $location.search()['geoJSON[box][1][]']
            ];
        }

        const specieFromUrl = getQueryParamArray('specie');
        const categoryFromUrl = getQueryParamArray('category');
        const typesFromUrl = getQueryParamArray('types');
        const locationFromUrl = getQueryParamArray('locationText');

        const data = {
            balcon: $location.search().balcon ? true : 0,
            breadcrumbs: $location.search().breadcrumbs ? true : false,
            city: $location.search()['city[]'] ? $location.search()['city[]'] : [],
            coordinates: [
                $location.search()['coordinates[0][]'] ? $location.search()['coordinates[0][]'] : [],
                $location.search()['coordinates[1][]'] ? $location.search()['coordinates[1][]'] : [],
            ],
            coordinateType: $location.search().coordinateType ? $location.search().coordinateType : '',
            country: $location.search().country ? $location.search().country : '',
            fullText: $location.search().fullText ? $location.search().fullText : '',
            kategoria: $location.search()['kategoria[]'] ? $location.search()['kategoria[]'] : null,
            locationText: locationFromUrl.length ? locationFromUrl : null,
            locationTextMobile: locationFromUrl.length ? locationFromUrl : '',
            geoJSON: geoJSON,
            new: $location.search().new ? true : 0,
            priceFrom: $location.search().priceFrom ? $location.search().priceFrom : 0,
            priceTo: $location.search().priceTo ? $location.search().priceTo : 0,
            region: $location.search()['region[]'] ? $location.search()['region[]'] : [],
            sizeFrom: $location.search().sizeFrom ? $location.search().sizeFrom : '',
            sizeTo: $location.search().sizeTo ? $location.search().sizeTo : '',
            specie: specieFromUrl.length === 0 ? '' : (specieFromUrl.length === 1 ? specieFromUrl[0] : specieFromUrl),
            category: categoryFromUrl,
            state: $location.search().state ? $location.search().state : '',
            type: $location.search().type ? $location.search().type : '',
            types: typesFromUrl,
            virtual: $location.search().virtual ? true : 0,

        }

        if ($scope.filterVersion.length && $scope.filterVersion == 'B' && data.type.length) {
            data.types = [data.type];
            data.type = '';
        }

        if (data.priceTo) {
            data.priceTo = parseInt(data.priceTo);
        }

        if (data.priceFrom) {
            data.priceFrom = parseInt(data.priceFrom);
        }

        if (data.sizeFrom) {
            data.sizeFrom = parseInt(data.sizeFrom);
        }

        if (data.sizeTo) {
            data.sizeTo = parseInt(data.sizeTo);
        }

        $scope.filter = angular.extend($scope.filter, data);
	initialFilter = angular.copy($scope.filter);

        // Keep category[] from URL while !inited; load subcategory chips for restored specie.
        if ($scope.filter.specie) {
            loadCategories($scope.filter.specie);
        }

        if (data.locationText) {
            if (angular.isString(data.locationText)) {
                $scope.locationText = [];
                $scope.locationText.push(data.locationText);
            } else if (angular.isArray(data.locationText)) {
                $scope.locationText = angular.copy(data.locationText);
            }
            toggleLocationText();
        }

        if (data.kategoria) {
            if (angular.isString(data.kategoria)) {
                $scope.kategoria = [];
                $scope.kategoria.push(data.kategoria);
            } else if (angular.isArray(data.kategoria)) {
                $scope.kategoria = angular.copy(data.kategoria);
            }
            toggleKategoria();
        }

        if (data.types) {
            if (angular.isString(data.types)) {
                $scope.types2 = [];
                $scope.types2.push(data.types);
            } else if (angular.isArray(data.types)) {
                $scope.types2 = angular.copy(data.types);
            }
            toggleTypes();
        }

        FilterProvider.loadSpecies()
            .then(function (species) {
                $scope.species = species;

                if ($scope.filter.specie) {
                    const selectedSpecies = Array.isArray($scope.filter.specie)
                        ? $scope.filter.specie
                        : [$scope.filter.specie];
                    $scope.species.forEach(function (item) {
                        item.checked = selectedSpecies.indexOf(item.value) !== -1;
                    });
                }
            });

        FilterProvider.loadTypes()
            .then(function (types) {
                $scope.types = types;

                if ($scope.filter.type) {
                    $scope.types.forEach(function (item) {
                        item.checked = (item.value === $scope.filter.type);
                    });
                }
            });

        loadStates();

        if (data.country) {
            //loadRegions(data.country);
            //const regions = angular.isDefined($location.search()['region[]']) ? $location.search()['region[]'] : [];

            FilterProvider.loadRegions(data.country)
                .then(function (regions) {
                    $scope.regions = regions;

                    const inputRegions = angular.isDefined($location.search()['region[]']) ? $location.search()['region[]'] : [];

                    if (inputRegions.length) {
                        $scope.regions.forEach(function (region) {
                            if (inputRegions.indexOf(region.id) !== -1) {
                                region.checked = true;
                            }
                        });
                    }
                });

            toggleRegion();
        }

        $(document).ready(function () {
            // listener pre "enter press"
            $('#paramFilterSection').find('input').keypress(function (e) {
                if ((event.keyCode || event.which) == 13) {
                    filterProjects();
                }
            });
        });

        // Enable specie-watch clearing only after URL restore finished.
        $timeout(function () {
            inited = true;
        }, 0);
    }

    function loadAmount() {
        $scope.loadingFilter = true;

        FilterProvider.loadAmount($scope.filter)
            .then(function (amount) {
                $scope.amount = amount;
            })
            .finally(function () {
                $scope.loadingFilter = false;
            });
    }

    function loadStates() {
        const promises = [];

        FilterProvider.loadStates()
            .then(function (states) {
                $scope.states = states;

                $scope.states.forEach(function (state) {
                    const promise = loadCountries(state.id).then(function (countries) {
                        state.countries = countries.map(function (country) {
                            country.placeholder = "<span class='country'>" + country.name + "</span>";
                            country.checked = $scope.filter.country === country.id;

                            return country;
                        });
                    });

                    promises.push(promise);
                });

                $q.all(promises).then(function () {
                    $scope.states.forEach(function (state) {
                        state.placeholder = "<span class='state'>" + state.name + "</span>";
                        state.checked = $scope.filter.state === state.id;
                        $scope.locations.push(state);
                        $scope.locations = $scope.locations.concat(state.countries);
                    });
                });
            });
    }

    function loadCountries(stateId) {
        const promise = FilterProvider.loadCountries(stateId)
            .then(function (countries) {
                $scope.countries = $scope.countries.concat(countries);

                return countries;
            });

        RealEstateSpinner.addPromise(promise);

        return promise;
    }

    function loadRegions(countryId) {
        const promise = FilterProvider.loadRegions(countryId)
            .then(function (regions) {
                $scope.regions = regions;

                const inputRegions = angular.isDefined($location.search()['region[]']) ? $location.search()['region[]'] : [];

                if (inputRegions.length) {
                    $scope.regions.forEach(function (region) {
                        if (inputRegions.indexOf(region.id) !== -1) {
                            region.checked = true;
                        }
                    });
                    toggleRegion();
                }
            });

        RealEstateSpinner.addPromise(promise);

        return promise;
    }

    function loadCities(regionsId) {
        const promise = FilterProvider.loadCities(regionsId)
            .then(function (cities) {
                $scope.cities = cities;

                const inputCities = angular.isDefined($location.search()['city[]']) ? $location.search()['city[]'] : [];

                if (inputCities.length) {
                    $scope.cities.forEach(function (city) {
                        if (inputCities.indexOf(city.id) !== -1) {
                            city.checked = true;
                        }
                    });

                    toggleCity();
                }
            });

        RealEstateSpinner.addPromise(promise);

        return promise;
    }

    let categoriesRequestId = 0;

    function loadCategories(specie) {
        const requestId = ++categoriesRequestId;

        if (!specie || (Array.isArray(specie) && !specie.length) || specie === '') {
            $scope.categories = [];
            return $q.resolve([]);
        }

        const promise = FilterProvider.loadCategories(specie)
            .then(function (categories) {
                if (requestId !== categoriesRequestId) {
                    return;
                }
                const selected = Array.isArray($scope.filter.category) ? $scope.filter.category : [];
                $scope.categories = (categories || []).map(function (category) {
                    category.checked = selected.indexOf(category.value) !== -1;
                    return category;
                });
            });

        RealEstateSpinner.addPromise(promise);

        return promise;
    }

    function toggleCategory() {
        const selectedCategories = [];

        $scope.categories.forEach(function (category) {
            if (category.checked) {
                selectedCategories.push(category.value);
            }
        });

        $scope.filter.category = selectedCategories;
        if ($scope.filter.breadcrumbs === true && $scope.filter.specie.length && $scope.filter.category.length) {
            const specieValue = Array.isArray($scope.filter.specie) ? $scope.filter.specie[0] : $scope.filter.specie;
            $scope.filter.kategoria = [specieValue + ',' + $scope.filter.category[0]];
        }
    }

    function toggleLocationText() {
        $scope.filter.locationText = angular.copy($scope.locationText);
    }

    function toggleKategoria() {
        $scope.filter.kategoria = angular.copy($scope.kategoria);
    }

    function toggleTypes() {
        $scope.filter.types = angular.copy($scope.types2);
    }

    function toggleRegion() {
        const selectedRegions = [];

        $scope.regions.forEach(function (region) {
            if (region.checked) {
                selectedRegions.push(region.id);
            }
        });

        $scope.filter.region = selectedRegions;
    }

    function toggleCity() {
        const selectedRegions = [];

        $scope.cities.forEach(function (city) {
            if (city.checked) {
                selectedRegions.push(city.id);
            }
        });

        $scope.filter.city = selectedRegions;
    }

    function filterProjects(showMap) {

        const fitlerData = {};
        const displayMap = showMap || false;

        angular.forEach($scope.filter, function (param, key) {
            if (key === 'locationTextMobile' || key === 'priceFrom' || key === 'priceTo') {
                return;
            }

            if (key === 'category' || key === 'types' || key === 'specie') {
                if (angular.isArray(param) && param.length) {
                    fitlerData[key] = param;
                } else if (!angular.isArray(param) && param) {
                    fitlerData[key] = param;
                }
                return;
            }
            
            if (param) {
                fitlerData[key] = param;
            }
        });
        
        if ($scope.filter.locationTextMobile && $scope.filter.locationTextMobile.length > 0) {
            fitlerData.locationText = $scope.filter.locationTextMobile;
        }

        // Do not send price filters unless the user actually set a positive value
        const priceFrom = parseInt($scope.filter.priceFrom, 10);
        const priceTo = parseInt($scope.filter.priceTo, 10);
        if (!isNaN(priceFrom) && priceFrom > 0) {
            fitlerData.priceFrom = priceFrom;
        }
        if (!isNaN(priceTo) && priceTo > 0) {
            fitlerData.priceTo = priceTo;
        }

        const queryString = $.param(fitlerData);
        const hash = displayMap ? '#map-filter' : '#result-filter';

        let href = projectsUrl + '?' + queryString;
        href = href + (queryString ? '&adverts' : 'adverts');

        if (angular.equals(initialFilter, $scope.filter)) {
            if (hash == '#map-filter') {
                $('#paramFilterSection').hide();
                $('#mapFilterSection').show();
                $('.adverts-list').hide();
                $('.tabNav').find('li').removeClass('active').eq(1).addClass('active');
            } else {
                $('.adverts-list').show();
            }
        }

        $window.location.href = href + hash;
    }

    $scope.toggleMobileType = function(typeValue) {
        if (!$scope.filter.types) {
            $scope.filter.types = [];
        }
        
        if (!Array.isArray($scope.filter.types)) {
            $scope.filter.types = [];
        }
        
        const index = $scope.filter.types.indexOf(typeValue);
        if (index > -1) {
            $scope.filter.types.splice(index, 1);
        } else {
            $scope.filter.types.push(typeValue);
        }
    };

    $scope.isMobileTypeSelected = function(typeValue) {
        if (!$scope.filter.types || !Array.isArray($scope.filter.types)) {
            return false;
        }
        return $scope.filter.types.indexOf(typeValue) > -1;
    };

    $scope.toggleMobileCategory = function(categoryValue) {
        let specieList = [];
        if ($scope.filter.specie) {
            specieList = Array.isArray($scope.filter.specie)
                ? $scope.filter.specie.slice()
                : [$scope.filter.specie];
        }

        const index = specieList.indexOf(categoryValue);
        if (index > -1) {
            specieList.splice(index, 1);
        } else {
            specieList.push(categoryValue);
        }

        specieList = specieList.filter(Boolean);
        $scope.filter.category = [];
        $scope.filter.specie = specieList.length ? specieList : '';
        loadCategories($scope.filter.specie);
    };

    $scope.isMobileCategorySelected = function(categoryValue) {
        if (!$scope.filter.specie) {
            return false;
        }
        if (Array.isArray($scope.filter.specie)) {
            return $scope.filter.specie.indexOf(categoryValue) > -1;
        }
        return $scope.filter.specie === categoryValue;
    };

    $scope.toggleMobileSubcategory = function(categoryValue) {
        if (!$scope.filter.category) {
            $scope.filter.category = [];
        }

        if (!Array.isArray($scope.filter.category)) {
            $scope.filter.category = [$scope.filter.category];
        }

        const index = $scope.filter.category.indexOf(categoryValue);
        if (index > -1) {
            $scope.filter.category.splice(index, 1);
        } else {
            $scope.filter.category.push(categoryValue);
        }

        $scope.categories.forEach(function (category) {
            category.checked = $scope.filter.category.indexOf(category.value) > -1;
        });
    };

    $scope.isMobileSubcategorySelected = function(categoryValue) {
        if (!$scope.filter.category) {
            return false;
        }
        if (Array.isArray($scope.filter.category)) {
            return $scope.filter.category.indexOf(categoryValue) > -1;
        }
        return $scope.filter.category === categoryValue;
    };

    $scope.shortCategoryLabel = function(label) {
        if (!label) {
            return '';
        }
        const match = String(label).match(/^(\d+)\s*-?\s*izb/i);
        if (match) {
            return match[1] + '-izb.';
        }
        return label;
    };

};
